export default function SectionShell({ title, description, action, children }) {
  return (
    <div className="min-h-full px-6 py-8 lg:px-10 lg:py-10" data-testid="section-shell">
      {/* ── Page header ── */}
      <header className="mb-8" data-testid="section-shell-header">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h1
              className="font-sans text-3xl font-extrabold tracking-tight text-[#323c44] sm:text-4xl"
              data-testid="section-shell-title"
            >
              {title}
            </h1>
            {description && (
              <p
                className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-500"
                data-testid="section-shell-description"
              >
                {description}
              </p>
            )}
          </div>
          {action ? (
            <div className="flex-shrink-0" data-testid="section-shell-action">
              {action}
            </div>
          ) : null}
        </div>
      </header>

      {/* ── Content ── */}
      {children}
    </div>
  );
}
